type Props = {
    size?: number;
    fill?: string;
};

export function XAxisIcon(props: Props) {
    const { size = 40, fill = 'black' } = props;

    return (
        <svg
            width={`${size}px`}
            height={`${size}px`}
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13 10 L13 84 L83 84"
                stroke={fill}
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <polygon points="93,84 78,76 78,92" fill={fill} />
            <text
                x="25"
                y="73"
                fontSize="32"
                fontStyle="italic"
                fontFamily="Georgia, 'Times New Roman', serif"
                fill={fill}
            >
                X
            </text>
        </svg>
    );
}
